import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import ImageGallery from "react-image-gallery";
import { Grid } from "semantic-ui-react";

import "react-image-gallery/styles/css/image-gallery.css";
import styles from "./styles.less";

class GalleryPopUp extends Component {
  constructor(props) {
    super(props);
    const { descriptionPosition } = this.props;
    this.descriptionClass = `${styles.descPosition} ${styles.top}`;
    if (descriptionPosition) {
      this.descriptionClass = styles.descPosition + " ";
      if (Array.isArray(descriptionPosition)) {
        this.descriptionClass += descriptionPosition
          .map(position => styles[position])
          .join(" ");
      } else {
        this.descriptionClass += styles[descriptionPosition];
      }
    }
  }
  _handleImageError = () => {
    // event
    /* we no longer recieve default image
        if (this.props.defaultImage &&
            event.target.src.indexOf(this.props.defaultImage) === -1) {
            event.target.src = this.props.defaultImage;
        }
        */
  };

  handleShowItemDetails = event => {
    const { handleShowItemDetails } = this.props;
    handleShowItemDetails(event);
  };

  _myImageGalleryRenderer = item => {
    const onImageError = this._handleImageError;
    return (
      <div className={cx("image-gallery-image", styles.imageGallery)}>
        <img
          style={{ backgroundImage: `url(${item.original})` }}
          src={item.original}
          alt={item.originalAlt}
          srcSet={item.srcSet}
          sizes={item.sizes}
          onLoad={this.props.onImageLoad}
          onError={onImageError}
        />
      </div>
    );
  };

  imageSrcWithCrop = src => {
    const { isMobileView } = this.props;
    if (isMobileView) {
      return `${src}?w=375&h=250&mode=crop`;
    } else {
      return src;
    }
  };

  imageSrcWithCropThumb = src => {
    const { isMobileView } = this.props;
    if (isMobileView) {
      return `${src}?w=375&h=250&mode=crop`;
    } else {
      return `${src}?w=150&h=100&mode=crop`;
    }
  };

  mapRoomImages = room => {
    let images = [];
    if (room) {
      if (room.images && room.images.length > 0) {
        images = room.images.map(image => ({
          original: image && this.imageSrcWithCrop(image),
          originalTitle: room.name,
          thumbnail: image && this.imageSrcWithCropThumb(image),
          description: room.roomDescription,
          price: room.TotalPrice,
          currency: room.currency
        }));
      } else {
        images = [
          {
            original: room.imageUrl && this.imageSrcWithCrop(room.imageUrl),
            originalTitle: room.name,
            thumbnail:
              room.imageUrl && this.imageSrcWithCropThumb(room.imageUrl),
            description: room.roomDescription,
            price: room.TotalPrice,
            currency: room.currency
          }
        ];
      }
    }
    return images;
  };

  render() {
    const { room, isRtl, showThumbnails, images } = this.props;
    const galleryImages = images != null ? images : this.mapRoomImages(room);
    return (
      <Grid.Column className={cx(styles.gallery, { [styles.rtl]: isRtl })}>
        <ImageGallery
          items={galleryImages || []}
          renderItem={this._myImageGalleryRenderer}
          showThumbnails={showThumbnails}
          showFullscreenButton={false}
          showPlayButton={false}
          showIndex
          showBullets
        />
      </Grid.Column>
    );
  }
}

GalleryPopUp.defaultProps = {
  showThumbnails: true
};

GalleryPopUp.propTypes = {
  isRtl: PropTypes.bool,
  descriptionPosition: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  room: PropTypes.object,
  onImageLoad: PropTypes.func,
  handleShowItemDetails: PropTypes.func,
  showThumbnails: PropTypes.bool,
  images: PropTypes.array,
  isMobileView: PropTypes.bool
};

export default GalleryPopUp;



// WEBPACK FOOTER //
// ./src/components/GalleryPopUp/GalleryPopUp.js